// Loxa Modal Script - Handles opt-in/opt-out functionality
document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('loxa-container');
  const modalOverlay = document.getElementById('loxa-modal-overlay');
  const modalClose = document.getElementById('loxa-modal-close');
  const backBtn = document.getElementById('loxa-back-btn');
  const optOutLink = document.getElementById('loxa-opt-out-link');
  const learnMoreLink = document.getElementById('loxa-learn-more');
  const loxaStateInput = document.getElementById('loxa-state');
  const badgeText = document.getElementById('loxa-badge-text');

  // Early exit if elements don't exist
  if (!container || !modalOverlay) {
    return;
  }

  // Track current state
  let isOptedIn = true;

  // Function to open modal
  function openModal() {
    modalOverlay.classList.add('active');
    document.body.style.overflow = 'hidden'; // Prevent background scrolling
    
    // Update modal button visibility based on current state
    if (isOptedIn) {
      // When opted in, show "Back to product" and "opt out" link
      backBtn.textContent = 'Back to product';
      if (optOutLink) {
        optOutLink.classList.remove('hidden');
      }
    } else {
      // When opted out, show "Include free protection" and hide "opt out" link
      backBtn.textContent = 'Include free protection';
      if (optOutLink) {
        optOutLink.classList.add('hidden');
      }
    }
  }

  // Function to close modal
  function closeModal() {
    modalOverlay.classList.remove('active');
    document.body.style.overflow = ''; // Restore scrolling
  }

  // Function to update UI based on opt-in state
  function updateUI(optedIn) {
    isOptedIn = optedIn;
    
    if (optedIn) {
      container.classList.remove('opted-out');
      if (loxaStateInput) {
        loxaStateInput.value = 'Included';
      }
      if (badgeText) {
        badgeText.textContent = 'Free 5-Year Protection Included';
      }
    } else {
      container.classList.add('opted-out');
      if (loxaStateInput) {
        loxaStateInput.value = 'Not Included';
      }
      if (badgeText) {
        badgeText.textContent = 'Protection Not Included - Click to add back';
      }
    }
  }

  // Click on container behavior depends on current state
  container.addEventListener('click', (e) => {
    e.preventDefault();
    
    // Always open modal, whether opted in or out
    openModal();
  });

  // Learn more link should open in new tab (default behavior)
  if (learnMoreLink) {
    learnMoreLink.addEventListener('click', (e) => {
      e.stopPropagation(); // Prevent container click handler
      // Link will open naturally with target="_blank"
    });
  }

  // Close modal when clicking X button
  if (modalClose) {
    modalClose.addEventListener('click', closeModal);
  }

  // Close modal when clicking outside the modal content
  modalOverlay.addEventListener('click', (e) => {
    if (e.target === modalOverlay) {
      closeModal();
    }
  });

  // Close modal with Escape key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modalOverlay.classList.contains('active')) {
      closeModal();
    }
  });

  // Back/Include button - behavior depends on current state
  if (backBtn) {
    backBtn.addEventListener('click', (e) => {
      e.preventDefault(); // Prevent link navigation
      
      if (isOptedIn) {
        // If opted in, button says "Back to product" - just close modal
        closeModal();
      } else {
        // If opted out, button says "Include free protection" - opt back in and close
        updateUI(true);
        closeModal();
      }
    });
  }

  // Opt-out link - disables protection and closes modal
  if (optOutLink) {
    optOutLink.addEventListener('click', (e) => {
      e.preventDefault();
      updateUI(false);
      closeModal();
    });
  }

  // Initialize - set default state to included
  updateUI(true);

  // Optional: Append price text if needed (keeping your original logic)
  const timeoutDuration = 10000; // 10 seconds
  const checkInterval = 200; // check every 200ms
  const startTime = Date.now();

  const intervalId = setInterval(() => {
    // Check if we should add price display anywhere
    const priceElements = document.querySelectorAll('[data-loxa-price]');
    
    if (priceElements.length > 0) {
      priceElements.forEach(element => {
        const text = element.textContent;
        const pricePattern = /\(\+£\d+\.\d{2}\)/;
        
        if (!pricePattern.test(text) && !text.includes('(+£0.00)')) {
          element.textContent += ' (+£0.00)';
        }
      });
      
      clearInterval(intervalId);
    } else if (Date.now() - startTime >= timeoutDuration) {
      clearInterval(intervalId);
    }
  }, checkInterval);
});
